import { GridLegacy } from "@mui/material";
import React from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormDatetime from "../../../components/Forms/FormDatetime";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper";

function Algemeen() {
  return (
    <Card style={{ maxWidth: 600 }}>
      <CardBody style={{ padding: 16, height: 500 }}>
        <GridLegacy container spacing={1}>
          <FormAsyncTC
            async={{
              url: "core/vestigingen/search?fields=id as value, systeemNaam as label&per_page=50",
              searchField: "systeemNaam",
            }}
            name={"vestiging_id"}
            rules={{ required: { value: true, message: getTranslation("This field is required!") } }}
            tDefault={"Sales area"}
            tKey={"preordering.form.algemeen.label.vestiging"}
          />
          <FormDatetime name={"datetime"} tDefault={"Date"} tKey={"preordering.form.algemeen.datum"} />

          <FormTextTC name={"name"} tDefault={"Naam"} tKey={"preordering.form.algemeen.naam"} />
        </GridLegacy>
      </CardBody>
    </Card>
  );
}

export default Algemeen;
